<app-toast [toastModel]="toastModel" *ngIf="isToastShow"></app-toast>
<div class="modal-header impact-outcome-header">
  <div class="modal-title f-20">Bulk Update</div>
  <div class="modal-btn-right">
    <div class="btn-group mr-4">
      <button
        class="btn btn-blue text-white btn-sm mr-2"
        (click)="updateSelfAssessment()"
        *ngIf="templateNo == 1 || templateNo == 2"
      >
        Save
      </button>
    </div>
    <button
      class="fa fa-times"
      [mat-dialog-close]=""
      style="float: right; cursor: pointer; background: none; border: none"
      aria-hidden="true"
    ></button>
  </div>
</div>

<div *ngIf="templateNo == 1" class="row mt-1 mb-1 mx-1">
  <div class="col-12 accordions">
    <mat-accordion id="AssessmentDetails">
      <mat-expansion-panel [expanded]="true" class="ia-expansion-panel pl-2">
        <mat-expansion-panel-header class="ia-mat-panel">
          <mat-panel-title>
            <span class="text-header inc-f"> Assessment Details </span>
          </mat-panel-title>
        </mat-expansion-panel-header>
        <div>
          <div class="row ml-2 mt-1">
            <div class="col-lg-2">
              <label class="control-label fw">Rule Applicable</label>
              <input
                type="text"
                placeholder="Pick one"
                aria-label="Number"
                name="rule applicable"
                matInput
                [matAutocomplete]="autoRA"
                style="margin-top: 8px"
                class="form-control form-control-sm border-bottom"
                [(ngModel)]="selfAssessment.ruleApplicable"
              />
              <mat-autocomplete autoActiveFirstOption #autoRA="matAutocomplete">
                <mat-option
                  *ngFor="let option of ruleApplicable"
                  [value]="option"
                >
                  {{ option }}
                </mat-option>
              </mat-autocomplete>
            </div>
            <div class="col-lg-10 edit_status_changeViewer_group">
              <label class="control-label fw">Assessment Description</label>
              <mat-form-field class="textarea_field w-100">
                <textarea
                  matInput
                  [(ngModel)]="selfAssessment.rationaleifNo"
                  class="text-area-css"
                  cdkTextareaAutosize
                ></textarea>
              </mat-form-field>
            </div>
          </div>

          <div class="row ml-2 my-4">
            <div class="col-lg-3">
              <label class="control-label fw">Assessment Team</label>
              <input
                type="text"
                class="form-control form-control-sm"
                [(ngModel)]="selfAssessment.assessmentTeam"
              />
            </div>
            <div class="col-lg-3">
              <label class="control-label fw">Assessor</label>
              <mat-chip-grid #assessorList>
                <mat-chip-row
                  *ngFor="let assessor of assessorDD"
                  [selectable]="selectable"
                  [removable]="removable"
                  (removed)="removeAssessor(assessor)"
                >
                  {{ assessor }}
                  <mat-icon matChipRemove *ngIf="removable">x</mat-icon>
                </mat-chip-row>
                <input
                  class="form-control form-control-sm mat-autodd-input h-33 border-bottom"
                  #assessorInput
                  [formControl]="searchAssessorCntrl"
                  [matAutocomplete]="assessorAutocomplete"
                  [matChipInputFor]="assessorList"
                  [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                  [matChipInputAddOnBlur]="addOnBlur"
                  autocomplete="off"
                  (matChipInputTokenEnd)="addAssessor($event)"
                />
              </mat-chip-grid>
              <mat-autocomplete
                #assessorAutocomplete="matAutocomplete"
                (optionSelected)="selectedAssessorEvent($event)"
              >
                <mat-option
                  *ngFor="let assessor of searchedAssessor"
                  [value]="assessor.value"
                >
                  {{ assessor.name }}
                </mat-option>
              </mat-autocomplete>
            </div>
            <div class="col-lg-3">
              <label class="control-label fw">Assessor Delegate</label>
              <mat-chip-grid #assessorDelList>
                <mat-chip-row
                  *ngFor="let assessor of assessorDelDD"
                  [selectable]="selectable"
                  [removable]="removable"
                  (removed)="removeAssessorDelegate(assessor)"
                >
                  {{ assessor }}
                  <mat-icon matChipRemove *ngIf="removable">x</mat-icon>
                </mat-chip-row>
                <input
                  class="form-control form-control-sm mat-autodd-input h-33 border-bottom"
                  #assessorDelInput
                  [formControl]="searchAssessorDelCntrl"
                  [matAutocomplete]="assessorDelAutocomplete"
                  [matChipInputFor]="assessorDelList"
                  [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                  [matChipInputAddOnBlur]="addOnBlur"
                  autocomplete="off"
                  (matChipInputTokenEnd)="addAssessorDelegate($event)"
                />
              </mat-chip-grid>
              <mat-autocomplete
                #assessorDelAutocomplete="matAutocomplete"
                (optionSelected)="selectedAssessorDelegateEvent($event)"
              >
                <mat-option
                  *ngFor="let assessor of searchedAssessorDel"
                  [value]="assessor.value"
                >
                  {{ assessor.name }}
                </mat-option>
              </mat-autocomplete>
            </div>
          </div>

          <div class="row ml-2 mt-1">
            <div class="col-lg-12">
              <div class="box-shadow p-2">
                <div class="header-text">
                  <span
                    class="fa fa-chevron-down cursor-pointer"
                    *ngIf="!isSADetails1"
                    (click)="isSADetails1 = true"
                  ></span>
                  <span
                    class="fa fa-chevron-up cursor-pointer"
                    *ngIf="isSADetails1"
                    (click)="isSADetails1 = false"
                  ></span>
                  <span class="control-label fw"> Assessment Details </span>
                </div>
                <!-- <ckeditor id="assessmentDetails" [editor]="Editor" *ngIf="isSADetails1"
                  [(ngModel)]="selfAssessment.assessmentDetails">
                </ckeditor> -->
                <app-ck-editor
                  [(childVariable)]="selfAssessment.assessmentDetails"
                  id="assessmentDetails"
                  *ngIf="isSADetails1"
                ></app-ck-editor>
              </div>
            </div>
          </div>

          <div class="row ml-2 mt-4">
            <div class="col-lg-3">
              <label class="control-label fw">Assessment Due Date</label>
              <div class="input-group input-group-sm">
                <input
                  matInput
                  [matDatepicker]="assessmentDueDate"
                  (click)="assessmentDueDate.open()"
                  class="form-control form-control-sm border-bottom"
                  [(ngModel)]="selfAssessment.assessmentDueDate"
                  name="AssessmentDueDate"
                />
                <div class="input-group-append">
                  <span
                    class="input-group-text fa fa-calendar"
                    (click)="assessmentDueDate.open()"
                  ></span>
                </div>
              </div>
              <mat-datepicker #assessmentDueDate> </mat-datepicker>
            </div>
            <div class="col-lg-3">
              <label class="control-label fw">Assessment Status</label>
              <input
                type="text"
                placeholder="Pick one"
                aria-label="Number"
                name="rule applicable"
                matInput
                [matAutocomplete]="autoAS"
                class="form-control form-control-sm border-bottom"
                [(ngModel)]="selfAssessment.assessmentStatus"
              />
              <mat-autocomplete autoActiveFirstOption #autoAS="matAutocomplete">
                <mat-option
                  *ngFor="let option of assessmentStatus"
                  [value]="option"
                >
                  {{ option }}
                </mat-option>
              </mat-autocomplete>
            </div>
          </div>
          <!-- <hr /> -->
        </div>
      </mat-expansion-panel>
    </mat-accordion>
    <mat-accordion id="ReviewDetails">
      <mat-expansion-panel [expanded]="true" class="ia-expansion-panel pl-2">
        <mat-expansion-panel-header class="ia-mat-panel">
          <mat-panel-title>
            <span class="text-header inc-f"> Review Details </span>
          </mat-panel-title>
        </mat-expansion-panel-header>
        <div>
          <div class="row ml-2 mt-1">
            <div class="col-lg-3">
              <label class="control-label fw">Reviewer Team</label>
              <input
                type="text"
                class="form-control form-control-sm"
                [(ngModel)]="selfAssessment.reviewTeam"
              />
            </div>
            <div class="col-lg-3">
              <label class="control-label fw">Reviewer</label>
              <mat-chip-grid #reviewerList>
                <mat-chip-row
                  *ngFor="let reviewer of reviewerDD"
                  [selectable]="selectable"
                  [removable]="removable"
                  (removed)="removeReviewer(reviewer)"
                >
                  {{ reviewer }}
                  <mat-icon matChipRemove *ngIf="removable">x</mat-icon>
                </mat-chip-row>
                <input
                  class="form-control form-control-sm h-33 mat-autodd-input border-bottom"
                  #reviewerInput
                  [formControl]="searchReviewerCntrl"
                  [matAutocomplete]="reviewerAutocomplete"
                  [matChipInputFor]="reviewerList"
                  [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                  [matChipInputAddOnBlur]="addOnBlur"
                  autocomplete="off"
                  (matChipInputTokenEnd)="addReviewer($event)"
                />
              </mat-chip-grid>
              <mat-autocomplete
                #reviewerAutocomplete="matAutocomplete"
                (optionSelected)="selectedReviewerEvent($event)"
              >
                <mat-option
                  *ngFor="let reviewer of searchedReviewer"
                  [value]="reviewer.value"
                >
                  {{ reviewer.name }}
                </mat-option>
              </mat-autocomplete>
            </div>
            <div class="col-lg-3">
              <label class="control-label fw">Reviewer Delegate</label>
              <mat-chip-grid #reviewerDelList>
                <mat-chip-row
                  *ngFor="let reviewer of reviewerDelDD"
                  [selectable]="selectable"
                  [removable]="removable"
                  (removed)="removeReviewerDelegate(reviewer)"
                >
                  {{ reviewer }}
                  <mat-icon matChipRemove *ngIf="removable">x</mat-icon>
                </mat-chip-row>
                <input
                  class="form-control form-control-sm h-33 mat-autodd-input border-bottom"
                  #reviewerDelInput
                  [formControl]="searchReviewerDelCntrl"
                  [matAutocomplete]="reviewerDelAutocomplete"
                  [matChipInputFor]="reviewerDelList"
                  [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                  [matChipInputAddOnBlur]="addOnBlur"
                  autocomplete="off"
                  (matChipInputTokenEnd)="addReviewerDelegate($event)"
                />
              </mat-chip-grid>
              <mat-autocomplete
                #reviewerDelAutocomplete="matAutocomplete"
                (optionSelected)="selectedReviewerDelegateEvent($event)"
              >
                <mat-option
                  *ngFor="let reviewer of searchedReviewerDel"
                  [value]="reviewer.value"
                >
                  {{ reviewer.name }}
                </mat-option>
              </mat-autocomplete>
            </div>
          </div>

          <div class="row ml-2 mt-1">
            <div class="col-lg-12">
              <div class="box-shadow p-2">
                <div class="header-text">
                  <span
                    class="fa fa-chevron-down cursor-pointer"
                    *ngIf="!isSADetails2"
                    (click)="isSADetails2 = true"
                  ></span>
                  <span
                    class="fa fa-chevron-up cursor-pointer"
                    *ngIf="isSADetails2"
                    (click)="isSADetails2 = false"
                  ></span>
                  <span class="control-label fw"> Review Details </span>
                </div>
                <!-- <ckeditor id="reviewDetails" [editor]="Editor" *ngIf="isSADetails2"
                  [(ngModel)]="selfAssessment.reviewDetails"></ckeditor> -->
                <app-ck-editor
                  [(childVariable)]="selfAssessment.reviewDetails"
                  id="reviewDetails"
                  *ngIf="isSADetails2"
                ></app-ck-editor>
              </div>
            </div>
          </div>

          <div class="row ml-2 mt-4">
            <div class="col-lg-3">
              <label class="control-label fw">Review Due Date</label>
              <div class="input-group input-group-sm">
                <input
                  matInput
                  [matDatepicker]="reviewDueDate"
                  (click)="reviewDueDate.open()"
                  class="form-control form-control-sm border-bottom"
                  [(ngModel)]="selfAssessment.reviewDueDate"
                  name="ReviewDueDate"
                />
                <div class="input-group-append">
                  <span
                    class="input-group-text fa fa-calendar"
                    (click)="reviewDueDate.open()"
                  ></span>
                </div>
              </div>
              <mat-datepicker #reviewDueDate></mat-datepicker>
            </div>
            <div class="col-lg-3">
              <label class="control-label fw">Review Status</label>
              <input
                type="text"
                placeholder="Pick one"
                aria-label="Number"
                name="rule applicable"
                matInput
                [matAutocomplete]="autoRS"
                class="form-control form-control-sm border-bottom"
                [(ngModel)]="selfAssessment.reviewStatus"
              />
              <mat-autocomplete autoActiveFirstOption #autoRS="matAutocomplete">
                <mat-option
                  *ngFor="let option of reviewStatus"
                  [value]="option"
                >
                  {{ option }}
                </mat-option>
              </mat-autocomplete>
            </div>
          </div>
          <!-- <hr> -->
        </div>
      </mat-expansion-panel>
    </mat-accordion>
    <mat-accordion id="OverallDetails">
      <mat-expansion-panel [expanded]="false" class="ia-expansion-panel pl-2">
        <mat-expansion-panel-header class="ia-mat-panel">
          <mat-panel-title>
            <span class="text-header inc-f"> Overall Details </span>
          </mat-panel-title>
        </mat-expansion-panel-header>
        <div>
          <div class="row ml-2 mt-1">
            <div class="col-lg-3 mr-3">
              <label class="control-label fw">Overall Status</label>
              <input
                type="text"
                placeholder="Pick one"
                aria-label="Number"
                name="OverallStatus"
                matInput
                [matAutocomplete]="autoOS"
                class="form-control form-control-sm border-bottom"
                [(ngModel)]="selfAssessment.overallStatus"
              />
              <mat-autocomplete autoActiveFirstOption #autoOS="matAutocomplete">
                <mat-option
                  *ngFor="let option of overallStatus"
                  [value]="option"
                >
                  {{ option }}
                </mat-option>
              </mat-autocomplete>
            </div>
            <div class="col-lg-3">
              <label class="control-label fw">Rule Conclusion</label>
              <input
                type="text"
                placeholder="Pick one"
                aria-label="Number"
                name="ruleConcusion"
                matInput
                [matAutocomplete]="autoRC"
                class="form-control form-control-sm border-bottom"
                [(ngModel)]="selfAssessment.ruleConclusion"
              />
              <mat-autocomplete autoActiveFirstOption #autoRC="matAutocomplete">
                <mat-option
                  *ngFor="let option of ruleConclusion"
                  [value]="option"
                >
                  {{ option }}
                </mat-option>
              </mat-autocomplete>
            </div>
          </div>

          <div class="row ml-2 mt-1">
            <div class="col-lg-12">
              <div class="box-shadow p-2">
                <div class="header-text">
                  <span
                    class="fa fa-chevron-down cursor-pointer"
                    *ngIf="!isSADetails3"
                    (click)="isSADetails3 = true"
                  ></span>
                  <span
                    class="fa fa-chevron-up cursor-pointer"
                    *ngIf="isSADetails3"
                    (click)="isSADetails3 = false"
                  ></span>
                  <span class="control-label fw"> Overall Conclusion </span>
                </div>
                <!-- <ckeditor id="overallConclusion" [editor]="Editor" [(ngModel)]="selfAssessment."
                  *ngIf="isSADetails3"></ckeditor> -->
                <app-ck-editor
                  [(childVariable)]="selfAssessment.overallConclusion"
                  id="overallConclusion"
                  *ngIf="isSADetails3"
                ></app-ck-editor>
              </div>
            </div>
          </div>
          <!-- <hr> -->
        </div>
      </mat-expansion-panel>
    </mat-accordion>
    <mat-accordion id="GapDetails">
      <mat-expansion-panel [expanded]="false" class="ia-expansion-panel pl-2">
        <mat-expansion-panel-header class="ia-mat-panel">
          <mat-panel-title>
            <span class="text-header inc-f"> Gap Details </span>
          </mat-panel-title>
        </mat-expansion-panel-header>
        <div>
          <div class="row ml-2 mt-1">
            <div class="col-lg-12">
              <div class="box-shadow p-2">
                <div class="header-text">
                  <span
                    class="fa fa-chevron-down cursor-pointer"
                    *ngIf="!isSADetails4"
                    (click)="isSADetails4 = true"
                  ></span>
                  <span
                    class="fa fa-chevron-up cursor-pointer"
                    *ngIf="isSADetails4"
                    (click)="isSADetails4 = false"
                  ></span>
                  <span class="control-label fw"> Gap Description </span>
                </div>
                <!-- <ckeditor id="gapDescription" [editor]="Editor" [(ngModel)]="selfAssessment.gapDescription"
                  *ngIf="isSADetails4"></ckeditor> -->
                <app-ck-editor
                  [(childVariable)]="selfAssessment.gapDescription"
                  id="gapDescription"
                  *ngIf="isSADetails4"
                ></app-ck-editor>
              </div>
            </div>
          </div>

          <div class="row ml-2 my-4">
            <div class="col-lg-3">
              <label class="control-label fw">Gap Review Status</label>
              <input
                type="text"
                placeholder="Pick one"
                aria-label="Number"
                name="rule applicable"
                matInput
                [(ngModel)]="selfAssessment.gapReviewStatus"
                [matAutocomplete]="autoGRS"
                class="form-control form-control-sm border-bottom"
              />
              <mat-autocomplete
                autoActiveFirstOption
                #autoGRS="matAutocomplete"
              >
                <mat-option
                  *ngFor="let option of gapReviewStatus"
                  [value]="option"
                >
                  {{ option }}
                </mat-option>
              </mat-autocomplete>
            </div>
            <div class="col-lg-3">
              <label class="control-label fw">Gap Action Team</label>
              <input
                type="text"
                [(ngModel)]="selfAssessment.actionTeam"
                class="form-control form-control-sm"
              />
            </div>
            <div class="col-lg-3">
              <label class="control-label fw">Gap Action Owner</label>
              <mat-chip-grid #actOwnerList>
                <mat-chip-row
                  *ngFor="let actOwner of actOwnerDD"
                  [selectable]="selectable"
                  [removable]="removable"
                  (removed)="removeActionOwner(actOwner)"
                >
                  {{ actOwner }}
                  <mat-icon matChipRemove *ngIf="removable">x</mat-icon>
                </mat-chip-row>
                <input
                  class="form-control form-control-sm h-33 mat-autodd-input border-bottom"
                  #actOwnerInput
                  [formControl]="searchActOwnerCntrl"
                  [matAutocomplete]="actOwnerAutocomplete"
                  [matChipInputFor]="actOwnerList"
                  [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                  [matChipInputAddOnBlur]="addOnBlur"
                  autocomplete="off"
                  (matChipInputTokenEnd)="addActionOwner($event)"
                />
              </mat-chip-grid>
              <mat-autocomplete
                #actOwnerAutocomplete="matAutocomplete"
                (optionSelected)="selectedActionOwnerEvent($event)"
              >
                <mat-option
                  *ngFor="let actOwner of searchedActOwner"
                  [value]="actOwner.value"
                >
                  {{ actOwner.name }}
                </mat-option>
              </mat-autocomplete>
            </div>
          </div>

          <div class="row ml-2 mt-1">
            <div class="col-lg-12">
              <div class="box-shadow p-2">
                <div class="header-text">
                  <span
                    class="fa fa-chevron-down cursor-pointer"
                    *ngIf="!isSADetails5"
                    (click)="isSADetails5 = true"
                  ></span>
                  <span
                    class="fa fa-chevron-up cursor-pointer"
                    *ngIf="isSADetails5"
                    (click)="isSADetails5 = false"
                  ></span>
                  <span class="control-label fw"> Gap Remediation Action </span>
                </div>
                <!-- <ckeditor id="remediationAction" *ngIf="isSADetails5" [editor]="Editor"
                  [(ngModel)]="selfAssessment.remediationAction"></ckeditor> -->
                <app-ck-editor
                  [(childVariable)]="selfAssessment.remediationAction"
                  id="remediationAction"
                  *ngIf="isSADetails5"
                ></app-ck-editor>
              </div>
            </div>
          </div>

          <div class="row ml-2 my-4">
            <div class="col-lg-3">
              <label class="control-label fw">Gap Action Due Date</label>
              <div class="input-group input-group-sm">
                <input
                  matInput
                  [matDatepicker]="actionDueDate"
                  (click)="actionDueDate.open()"
                  class="form-control form-control-sm border-bottom"
                  [(ngModel)]="selfAssessment.actionDueDate"
                  name="ActionDueDate"
                />
                <div class="input-group-append">
                  <span
                    class="input-group-text fa fa-calendar"
                    (click)="actionDueDate.open()"
                  ></span>
                </div>
              </div>
              <mat-datepicker #actionDueDate></mat-datepicker>
            </div>
            <div class="col-lg-3">
              <label class="control-label fw">Gap Action Status</label>
              <input
                type="text"
                placeholder="Pick one"
                aria-label="Number"
                name="actionStatus"
                matInput
                [matAutocomplete]="autoACS"
                class="form-control form-control-sm border-bottom"
                [(ngModel)]="selfAssessment.actionStatus"
              />
              <mat-autocomplete
                autoActiveFirstOption
                #autoACS="matAutocomplete"
              >
                <mat-option
                  *ngFor="let option of actionStatus"
                  [value]="option"
                >
                  {{ option }}
                </mat-option>
              </mat-autocomplete>
            </div>
          </div>

          <div class="row ml-2 mt-1">
            <div class="col-lg-12">
              <div class="box-shadow p-2">
                <div class="header-text">
                  <span
                    class="fa fa-chevron-down cursor-pointer"
                    *ngIf="!isSADetails6"
                    (click)="isSADetails6 = true"
                  ></span>
                  <span
                    class="fa fa-chevron-up cursor-pointer"
                    *ngIf="isSADetails6"
                    (click)="isSADetails6 = false"
                  ></span>
                  <span class="control-label fw"> Gap Closure Rationale </span>
                </div>
                <!-- <ckeditor id="closureRationale" *ngIf="isSADetails6" [editor]="Editor"
                  [(ngModel)]="selfAssessment.closureRationale"></ckeditor> -->
                <app-ck-editor
                  [(childVariable)]="selfAssessment.closureRationale"
                  id="closureRationale"
                  *ngIf="isSADetails6"
                ></app-ck-editor>
              </div>
            </div>
          </div>
        </div>
      </mat-expansion-panel>
    </mat-accordion>
    <mat-accordion id="EnhancementDetails">
      <mat-expansion-panel [expanded]="false" class="ia-expansion-panel pl-2">
        <mat-expansion-panel-header class="ia-mat-panel">
          <mat-panel-title>
            <span class="text-header inc-f"> Enhancement Details </span>
          </mat-panel-title>
        </mat-expansion-panel-header>
        <div id="EnhancementDetails">
          <div class="row ml-2 mt-1">
            <div class="col-lg-12">
              <div class="box-shadow p-2">
                <div class="header-text">
                  <span
                    class="fa fa-chevron-down cursor-pointer"
                    *ngIf="!isSADetails7"
                    (click)="isSADetails7 = true"
                  ></span>
                  <span
                    class="fa fa-chevron-up cursor-pointer"
                    *ngIf="isSADetails7"
                    (click)="isSADetails7 = false"
                  ></span>
                  <span class="control-label fw">
                    Enhancement Description
                  </span>
                </div>
                <!-- <ckeditor id="enhancementDescription" *ngIf="isSADetails7" [editor]="Editor"
                  [(ngModel)]="selfAssessment.enhancementDescription">
                </ckeditor> -->
                <app-ck-editor
                  [(childVariable)]="selfAssessment.enhancementDescription"
                  id="enhancementDescription"
                  *ngIf="isSADetails7"
                ></app-ck-editor>
              </div>
            </div>
          </div>

          <div class="row ml-2 my-5">
            <div class="col-lg-3">
              <label class="control-label fw">Enhancement Review Status</label>
              <input
                type="text"
                placeholder="Pick one"
                aria-label="Number"
                name="Enhancement review status"
                matInput
                [(ngModel)]="selfAssessment.enhancementReviewStatus"
                [matAutocomplete]="autoERS"
                class="form-control form-control-sm border-bottom"
              />
              <mat-autocomplete
                autoActiveFirstOption
                #autoERS="matAutocomplete"
              >
                <mat-option
                  *ngFor="let option of enhancementReviewStatus"
                  [value]="option"
                >
                  {{ option }}
                </mat-option>
              </mat-autocomplete>
            </div>
            <div class="col-lg-3">
              <label class="control-label fw">Enhancement Action Team</label>
              <input
                type="text"
                [(ngModel)]="selfAssessment.enhancementActionTeam"
                class="form-control form-control-sm"
              />
            </div>
            <div class="col-lg-3">
              <label class="control-label fw">Enhancement Action Owner</label>
              <mat-chip-grid #enhmtActOwnerList>
                <mat-chip-row
                  *ngFor="let enhmtActOwner of enhmtActOwnerDD"
                  [selectable]="selectable"
                  [removable]="removable"
                  (removed)="removeActionOwner(enhmtActOwner)"
                >
                  {{ enhmtActOwner }}
                  <mat-icon matChipRemove *ngIf="removable">x</mat-icon>
                </mat-chip-row>
                <input
                  class="form-control form-control-sm h-33 mat-autodd-input border-bottom"
                  #enhmtActOwnerInput
                  [formControl]="searchEnhmtActOwnerCntrl"
                  [matAutocomplete]="enhmtActOwnerAutocomplete"
                  [matChipInputFor]="enhmtActOwnerList"
                  [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                  [matChipInputAddOnBlur]="addOnBlur"
                  autocomplete="off"
                  (matChipInputTokenEnd)="addEnhmtActionOwner($event)"
                />
              </mat-chip-grid>
              <mat-autocomplete
                #enhmtActOwnerAutocomplete="matAutocomplete"
                (optionSelected)="selectedEnhmtActionOwnerEvent($event)"
              >
                <mat-option
                  *ngFor="let enhmtActOwner of searchedEnhmtActOwner"
                  [value]="enhmtActOwner.value"
                >
                  {{ enhmtActOwner.name }}
                </mat-option>
              </mat-autocomplete>
            </div>
          </div>

          <div class="row ml-2 mt-1">
            <div class="col-lg-12">
              <div class="box-shadow p-2">
                <div class="header-text">
                  <span
                    class="fa fa-chevron-down cursor-pointer"
                    *ngIf="!isSADetails8"
                    (click)="isSADetails8 = true"
                  ></span>
                  <span
                    class="fa fa-chevron-up cursor-pointer"
                    *ngIf="isSADetails8"
                    (click)="isSADetails8 = false"
                  ></span>
                  <span class="control-label fw"> Enhancement Action </span>
                </div>
                <!-- <ckeditor id="enhancementAction" *ngIf="isSADetails8" [editor]="Editor"
                  [(ngModel)]="selfAssessment.enhancementAction">
                </ckeditor> -->
                <app-ck-editor
                  [(childVariable)]="selfAssessment.enhancementAction"
                  id="enhancementAction"
                  *ngIf="isSADetails8"
                ></app-ck-editor>
              </div>
            </div>
          </div>

          <div class="row ml-2 mt-5">
            <div class="col-lg-3">
              <label class="control-label fw"
                >Enhancement Action Due Date</label
              >
              <div class="input-group input-group-sm">
                <input
                  matInput
                  [matDatepicker]="enhancementDueDate"
                  (click)="enhancementDueDate.open()"
                  class="form-control form-control-sm border-bottom"
                  [(ngModel)]="selfAssessment.enhancementActionDueDate"
                  name="EnhancementDueDate"
                />
                <div class="input-group-append">
                  <span
                    class="input-group-text fa fa-calendar"
                    (click)="enhancementDueDate.open()"
                  ></span>
                </div>
              </div>
              <mat-datepicker #enhancementDueDate></mat-datepicker>
            </div>
            <div class="col-lg-3">
              <label class="control-label fw">Enhancement Action Status</label>
              <input
                type="text"
                placeholder="Pick one"
                aria-label="Number"
                name="enhancementActionStatus"
                matInput
                [matAutocomplete]="autoEACS"
                class="form-control form-control-sm border-bottom"
                [(ngModel)]="selfAssessment.enhancementActionStatus"
              />
              <mat-autocomplete
                autoActiveFirstOption
                #autoEACS="matAutocomplete"
              >
                <mat-option
                  *ngFor="let option of enhancementActionStatus"
                  [value]="option"
                >
                  {{ option }}
                </mat-option>
              </mat-autocomplete>
            </div>
          </div>
        </div>
      </mat-expansion-panel>
    </mat-accordion>
  </div>
</div>

<!-- For Template 2 -->
<div *ngIf="templateNo == 2" class="row mt-1 mb-1 mx-1">
  <div class="col-12 accordions">
    <mat-accordion id="OverallAssessment">
      <mat-expansion-panel [expanded]="true" class="ia-expansion-panel pl-2">
        <mat-expansion-panel-header class="ia-mat-panel">
          <mat-panel-title>
            <span class="text-header inc-f"> Overall Assessment </span>
          </mat-panel-title>
        </mat-expansion-panel-header>
        <div>
          <div class="row ml-2 mt-1">
            <div class="col-lg-4">
              <label class="control-label fw">Assessment Due Date</label>
              <div class="input-group input-group-sm">
                <input
                  matInput
                  [matDatepicker]="assessmentDueDate"
                  (click)="assessmentDueDate.open()"
                  class="form-control form-control-sm border-bottom"
                  [(ngModel)]="selfAssessmentNew.assessmentDueDate"
                  name="AssessmentDueDate"
                />
                <div class="input-group-append">
                  <span
                    class="input-group-text fa fa-calendar"
                    (click)="assessmentDueDate.open()"
                  ></span>
                </div>
              </div>
              <mat-datepicker #assessmentDueDate> </mat-datepicker>
            </div>
            <div class="col-lg-4">
              <label class="control-label fw">Assessment Category</label>
              <input
                type="text"
                placeholder="Pick one"
                aria-label="Number"
                name="assessmentCategory"
                matInput
                [matAutocomplete]="autoRA"
                style="margin-top: 0px"
                class="form-control form-control-sm border-bottom"
                [(ngModel)]="selfAssessmentNew.assessmentCategory"
              />
              <mat-autocomplete autoActiveFirstOption #autoRA="matAutocomplete">
                <mat-option
                  *ngFor="let option of assessmentCategory2"
                  [value]="option"
                >
                  {{ option }}
                </mat-option>
              </mat-autocomplete>
            </div>
          </div>

          <div class="row ml-2 my-4">
            <div class="col-lg-3">
              <label class="control-label fw">Assessment Team</label>
              <input
                type="text"
                placeholder="Pick one"
                aria-label="Number"
                name="assessmentTeam"
                matInput
                [matAutocomplete]="autoAT"
                style="margin-top: 0px"
                class="form-control form-control-sm border-bottom"
                [(ngModel)]="selfAssessmentNew.assessmentTeam"
              />
              <mat-autocomplete autoActiveFirstOption #autoAT="matAutocomplete">
                <mat-option
                  *ngFor="let option of assessmentTeam2"
                  [value]="option"
                >
                  {{ option }}
                </mat-option>
              </mat-autocomplete>
            </div>
            <div class="col-lg-3">
              <label class="control-label fw">Assessment Status</label>
              <input
                type="text"
                placeholder="Pick one"
                aria-label="Number"
                name="assessmentStatus"
                matInput
                [matAutocomplete]="autoAS"
                class="form-control form-control-sm border-bottom"
                [(ngModel)]="selfAssessmentNew.assessmentStatus"
              />
              <mat-autocomplete autoActiveFirstOption #autoAS="matAutocomplete">
                <mat-option
                  *ngFor="let option of assessmentStatus2"
                  [value]="option"
                >
                  {{ option }}
                </mat-option>
              </mat-autocomplete>
            </div>
            <div class="col-lg-3">
              <label class="control-label fw">Compliance Status</label>
              <input
                type="text"
                placeholder="Pick one"
                aria-label="Number"
                name="complianceStatus"
                matInput
                [matAutocomplete]="autoCS"
                class="form-control form-control-sm border-bottom"
                [(ngModel)]="selfAssessmentNew.complianceStatus"
              />
              <mat-autocomplete autoActiveFirstOption #autoCS="matAutocomplete">
                <mat-option
                  *ngFor="let option of complianceStatus2"
                  [value]="option"
                >
                  {{ option }}
                </mat-option>
              </mat-autocomplete>
            </div>
          </div>
          <div class="row ml-2 my-4">
            <div class="col-lg-6">
              <label class="control-label fw">Assessor</label>
              <mat-chip-grid #assessorList2>
                <mat-chip-row
                  *ngFor="let assessor of assessorDD2"
                  [selectable]="selectable"
                  [removable]="removable"
                  (removed)="removeAssessor2(assessor)"
                >
                  {{ assessor }}
                  <mat-icon matChipRemove *ngIf="removable">x</mat-icon>
                </mat-chip-row>
                <input
                  class="form-control form-control-sm mat-autodd-input h-33 border-bottom"
                  #assessorInput2
                  [formControl]="searchAssessorCntrl2"
                  [matAutocomplete]="assessorAutocomplete2"
                  [matChipInputFor]="assessorList2"
                  [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                  [matChipInputAddOnBlur]="addOnBlur"
                  autocomplete="off"
                  (matChipInputTokenEnd)="addAssessor2($event)"
                />
              </mat-chip-grid>
              <mat-autocomplete
                #assessorAutocomplete2="matAutocomplete"
                (optionSelected)="selectedAssessorEvent2($event)"
              >
                <mat-option
                  *ngFor="let assessor of searchedAssessor2"
                  [value]="assessor.value"
                >
                  {{ assessor.name }}
                </mat-option>
              </mat-autocomplete>
            </div>
            <div class="col-lg-6">
              <label class="control-label fw">Assessment Description</label>
              <input
                type="text"
                class="form-control form-control-sm"
                [(ngModel)]="selfAssessmentNew.assessmentDescription"
              />
            </div>
          </div>
          <!-- <div class="row ml-2 mt-1">
            <div class="col-lg-12 mb-1">
              <div class="box-shadow p-2">
                <div class="header-text">
                  <span class="fa fa-chevron-down cursor-pointer" *ngIf="!isSA2Details1"
                    (click)="isSA2Details1 = true"></span>
                  <span class="fa fa-chevron-up cursor-pointer" *ngIf="isSA2Details1"
                    (click)="isSA2Details1 = false"></span>
                  <span class="control-label fw">
                    Assessment Details
                  </span>
                </div>
                <ckeditor id="assessmentDetails2" [editor]="Editor" *ngIf="isSA2Details1"
                  [(ngModel)]="selfAssessmentNew.assessmentDetails">
                </ckeditor>
                <app-ck-editor [(childVariable)]="selfAssessmentNew.assessmentDetails" id="assessmentDetails2"
                  *ngIf="isSA2Details1"></app-ck-editor>
              </div>
            </div>
          </div> -->
        </div>
      </mat-expansion-panel>
    </mat-accordion>
    <mat-accordion id="Interpretations">
      <mat-expansion-panel [expanded]="false" class="ia-expansion-panel pl-2">
        <mat-expansion-panel-header class="ia-mat-panel">
          <mat-panel-title>
            <span class="text-header inc-f"> Interpretations </span>
          </mat-panel-title>
        </mat-expansion-panel-header>
        <div>
          <div class="row ml-2 mt-1">
            <div class="col-lg-3 mr-3 mb-3">
              <label class="control-label fw">Interpretations</label>
              <input
                type="text"
                placeholder="Pick one"
                aria-label="Number"
                name="Interpretations"
                matInput
                [matAutocomplete]="autoIP"
                class="form-control form-control-sm border-bottom"
                [(ngModel)]="selfAssessmentNew.interpretation"
              />
              <mat-autocomplete autoActiveFirstOption #autoIP="matAutocomplete">
                <mat-option
                  *ngFor="let option of interpretations2"
                  [value]="option"
                >
                  {{ option }}
                </mat-option>
              </mat-autocomplete>
            </div>
          </div>

          <!-- <div class="row ml-2 mt-1">
            <div class="col-lg-12 mb-1">
              <div class="box-shadow p-2">
                <div class="header-text">
                  <span class="fa fa-chevron-down cursor-pointer" *ngIf="!isSA2Details2"
                    (click)="isSA2Details2 = true"></span>
                  <span class="fa fa-chevron-up cursor-pointer" *ngIf="isSA2Details2"
                    (click)="isSA2Details2 = false"></span>
                  <span class="control-label fw">
                    Interpretation Details
                  </span>
                </div>
                 <ckeditor id="interpretationDetails" [editor]="Editor"
                  [(ngModel)]="selfAssessmentNew.interpretationDetails" *ngIf="isSA2Details2">
                </ckeditor>
                <app-ck-editor [(childVariable)]="selfAssessmentNew.interpretationDetails" id="interpretationDetails"
                  *ngIf="isSA2Details2"></app-ck-editor>
              </div>
            </div>
          </div> -->
        </div>
      </mat-expansion-panel>
    </mat-accordion>
    <mat-accordion id="DataJudgements">
      <mat-expansion-panel [expanded]="false" class="ia-expansion-panel pl-2">
        <mat-expansion-panel-header class="ia-mat-panel">
          <mat-panel-title>
            <span class="text-header inc-f"> Data Judgements </span>
          </mat-panel-title>
        </mat-expansion-panel-header>
        <div>
          <div class="row ml-2 mt-1">
            <div class="col-lg-4 mb-3">
              <label class="control-label fw">Judgement</label>
              <input
                type="text"
                placeholder="Pick one"
                aria-label="Number"
                name="Judgement"
                matInput
                [matAutocomplete]="autoJ"
                class="form-control form-control-sm border-bottom"
                [(ngModel)]="selfAssessmentNew.judgement"
              />
              <mat-autocomplete autoActiveFirstOption #autoJ="matAutocomplete">
                <mat-option *ngFor="let option of judgement2" [value]="option">
                  {{ option }}
                </mat-option>
              </mat-autocomplete>
            </div>
            <div class="col-lg-4 mb-3">
              <label class="control-label fw">No. of Judgements</label>
              <input
                type="number"
                class="form-control form-control-sm"
                [(ngModel)]="selfAssessmentNew.noOfJudgements"
              />
            </div>
          </div>

          <!-- <div class="row ml-2 mt-1">
            <div class="col-lg-12 mb-1">
              <div class="box-shadow p-2">
                <div class="header-text">
                  <span class="fa fa-chevron-down cursor-pointer" *ngIf="!isSA2Details3"
                    (click)="isSA2Details3 = true"></span>
                  <span class="fa fa-chevron-up cursor-pointer" *ngIf="isSA2Details3"
                    (click)="isSA2Details3 = false"></span>
                  <span class="control-label fw">
                    Judgement Details
                  </span>
                </div>
                <ckeditor id="judgementDetails" [editor]="Editor" [(ngModel)]="selfAssessmentNew.judgementDetails"
                  *ngIf="isSA2Details3">
                </ckeditor>
                <app-ck-editor [(childVariable)]="selfAssessmentNew.judgementDetails" id="judgementDetails"
                  *ngIf="isSA2Details3"></app-ck-editor>
              </div>
            </div>
          </div> -->
        </div>
      </mat-expansion-panel>
    </mat-accordion>
    <mat-accordion id="ComplianceGaps">
      <mat-expansion-panel [expanded]="false" class="ia-expansion-panel pl-2">
        <mat-expansion-panel-header class="ia-mat-panel">
          <mat-panel-title>
            <span class="text-header inc-f"> Gaps </span>
          </mat-panel-title>
        </mat-expansion-panel-header>
        <div>
          <div class="row ml-2 mt-1">
            <div class="col-lg-3 mb-3">
              <label class="control-label fw">Gaps</label>
              <input
                type="text"
                placeholder="Pick one"
                aria-label="Number"
                name="Gaps"
                matInput
                [matAutocomplete]="autoG"
                class="form-control form-control-sm border-bottom"
                [(ngModel)]="selfAssessmentNew.gaps"
              />
              <mat-autocomplete autoActiveFirstOption #autoG="matAutocomplete">
                <mat-option *ngFor="let option of gaps2" [value]="option">
                  {{ option }}
                </mat-option>
              </mat-autocomplete>
            </div>
            <div class="col-lg-3 mb-3">
              <label class="control-label fw">No. of Gaps</label>
              <input
                type="number"
                class="form-control form-control-sm"
                [(ngModel)]="selfAssessmentNew.noOfGaps"
              />
            </div>
            <div class="col-lg-3 mb-3">
              <label class="control-label fw"
                >No. of Gaps Requiring Action</label
              >
              <input
                type="number"
                class="form-control form-control-sm"
                [(ngModel)]="selfAssessmentNew.noOfGapsRiskAccepted"
              />
            </div>
            <div class="col-lg-3 mb-3">
              <label class="control-label fw">Gap Action Due Date</label>
              <div class="input-group input-group-sm">
                <input
                  matInput
                  [matDatepicker]="gapActionDueDate"
                  (click)="gapActionDueDate.open()"
                  class="form-control form-control-sm border-bottom"
                  [(ngModel)]="selfAssessmentNew.gapActionDueDate"
                  name="GapActionDueDate"
                />
                <div class="input-group-append">
                  <span
                    class="input-group-text fa fa-calendar"
                    (click)="gapActionDueDate.open()"
                  ></span>
                </div>
              </div>
              <mat-datepicker #gapActionDueDate> </mat-datepicker>
            </div>
            <!-- <div class="col-lg-12 mb-1">
              <div class="box-shadow p-2">
                <div class="header-text">
                  <span class="fa fa-chevron-down cursor-pointer" *ngIf="!isSA2Details4"
                    (click)="isSA2Details4 = true"></span>
                  <span class="fa fa-chevron-up cursor-pointer" *ngIf="isSA2Details4"
                    (click)="isSA2Details4 = false"></span>
                  <span class="control-label fw">
                    Gap Detail
                  </span>
                </div>
                <ckeditor id="gapDetail" [editor]="Editor" [(ngModel)]="selfAssessmentNew.gapDetail"
                  *ngIf="isSA2Details4">
                </ckeditor>
                <app-ck-editor [(childVariable)]="selfAssessmentNew.gapDetail" id="gapDetail"
                  *ngIf="isSA2Details4"></app-ck-editor>
              </div>
            </div> -->
          </div>
        </div>
      </mat-expansion-panel>
    </mat-accordion>
    <mat-accordion id="EnhancementDetails">
      <mat-expansion-panel [expanded]="false" class="ia-expansion-panel pl-2">
        <mat-expansion-panel-header class="ia-mat-panel">
          <mat-panel-title>
            <span class="text-header inc-f"> Enhancement Details </span>
          </mat-panel-title>
        </mat-expansion-panel-header>
        <div id="EnhancementDetails">
          <div class="row ml-2 my-1">
            <div class="col-lg-4 mb-3">
              <label class="control-label fw">Enhancements</label>
              <input
                type="text"
                placeholder="Pick one"
                aria-label="Number"
                name="Enhancements"
                matInput
                [matAutocomplete]="autoE"
                class="form-control form-control-sm border-bottom"
                [(ngModel)]="selfAssessmentNew.enhancement"
              />
              <mat-autocomplete autoActiveFirstOption #autoE="matAutocomplete">
                <mat-option
                  *ngFor="let option of enhancement2"
                  [value]="option"
                >
                  {{ option }}
                </mat-option>
              </mat-autocomplete>
            </div>
            <div class="col-lg-4 mb-3">
              <label class="control-label fw">No. of Enhancement</label>
              <input
                type="number"
                class="form-control form-control-sm"
                [(ngModel)]="selfAssessmentNew.noOfEnhancement"
              />
            </div>
            <div class="col-lg-4 mb-3">
              <label class="control-label fw"
                >No. of Risk Recommendations</label
              >
              <input
                type="text"
                placeholder="Pick one"
                aria-label="Number"
                name="RiskRecommendation"
                matInput
                [matAutocomplete]="autoRiR"
                class="form-control form-control-sm border-bottom"
                [(ngModel)]="selfAssessmentNew.riskRecommendation"
              />
              <mat-autocomplete
                autoActiveFirstOption
                #autoRiR="matAutocomplete"
              >
                <mat-option
                  *ngFor="let option of riskRecommendation2"
                  [value]="option"
                >
                  {{ option }}
                </mat-option>
              </mat-autocomplete>
            </div>
            <div class="col-lg-4 mb-3">
              <label class="control-label fw"
                >No. of Risk Recommendations Due Date</label
              >
              <div class="input-group input-group-sm">
                <input
                  matInput
                  [matDatepicker]="riskRecommendationDueDate"
                  (click)="riskRecommendationDueDate.open()"
                  class="form-control form-control-sm border-bottom"
                  [(ngModel)]="selfAssessmentNew.riskRecommendationDueDate"
                  name="RiskRecommendationDueDate"
                />
                <div class="input-group-append">
                  <span
                    class="input-group-text fa fa-calendar"
                    (click)="riskRecommendationDueDate.open()"
                  ></span>
                </div>
              </div>
              <mat-datepicker #riskRecommendationDueDate> </mat-datepicker>
            </div>
            <!-- <div class="col-lg-4 mb-3">
              <label class="control-label fw">Risk Recommendations Status</label>
              <input type="text" placeholder="Pick one" aria-label="Number" name="RiskRecommendationStatus" matInput
                [(ngModel)]="selfAssessmentNew.riskRecommendationStatus" [matAutocomplete]="autoRRS"
                class="form-control form-control-sm border-bottom" />
              <mat-autocomplete autoActiveFirstOption #autoRRS="matAutocomplete">
                <mat-option *ngFor="let option of riskRecommendationStatus2" [value]="option">
                  {{option}}
                </mat-option>
              </mat-autocomplete>
            </div> Removed on request of LBG -->
          </div>
          <!-- <div class="row ml-2 mt-1">
            <div class="col-lg-12 mb-1">
              <div class="box-shadow p-2">
                <div class="header-text">
                  <span class="fa fa-chevron-down cursor-pointer" *ngIf="!isSA2Details5"
                    (click)="isSA2Details5 = true"></span>
                  <span class="fa fa-chevron-up cursor-pointer" *ngIf="isSA2Details5"
                    (click)="isSA2Details5 = false"></span>
                  <span class="control-label fw">
                    Enhancement Description
                  </span>
                </div>
                <ckeditor id="enhancementDescription" *ngIf="isSA2Details5" [editor]="Editor"
                  [(ngModel)]="selfAssessmentNew.enhancementDescription">
                </ckeditor>
                <app-ck-editor [(childVariable)]="selfAssessmentNew.enhancementDescription" id="enhancementDescription"
                  *ngIf="isSA2Details5"></app-ck-editor>
              </div>
            </div>
          </div> -->
        </div>
      </mat-expansion-panel>
    </mat-accordion>
    <mat-accordion id="ReviewDetails">
      <mat-expansion-panel [expanded]="true" class="ia-expansion-panel pl-2">
        <mat-expansion-panel-header class="ia-mat-panel">
          <mat-panel-title>
            <span class="text-header inc-f"> Review Details </span>
          </mat-panel-title>
        </mat-expansion-panel-header>
        <div>
          <div class="row ml-2 mt-1">
            <div class="col-lg-3 mb-3">
              <label class="control-label fw">Reviewer Team</label>
              <input
                type="text"
                placeholder="Pick one"
                aria-label="Number"
                name="reviewerTeam"
                matInput
                [matAutocomplete]="autoRT"
                class="form-control form-control-sm border-bottom"
                [(ngModel)]="selfAssessmentNew.reviewerTeam"
              />
              <mat-autocomplete autoActiveFirstOption #autoRT="matAutocomplete">
                <mat-option
                  *ngFor="let option of reviewerTeam2"
                  [value]="option"
                >
                  {{ option }}
                </mat-option>
              </mat-autocomplete>
            </div>
            <div class="col-lg-4 mb-3">
              <label class="control-label fw">Reviewer</label>
              <mat-chip-grid #reviewerList>
                <mat-chip-row
                  *ngFor="let reviewer of reviewerDD2"
                  [selectable]="selectable"
                  [removable]="removable"
                  (removed)="removeReviewer2(reviewer)"
                >
                  {{ reviewer }}
                  <mat-icon matChipRemove *ngIf="removable">x</mat-icon>
                </mat-chip-row>
                <input
                  class="form-control form-control-sm h-33 mat-autodd-input border-bottom"
                  #reviewerInput
                  [formControl]="searchReviewerCntrl2"
                  [matAutocomplete]="reviewerAutocomplete2"
                  [matChipInputFor]="reviewerList"
                  [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                  [matChipInputAddOnBlur]="addOnBlur"
                  autocomplete="off"
                  (matChipInputTokenEnd)="addReviewer2($event)"
                />
              </mat-chip-grid>
              <mat-autocomplete
                #reviewerAutocomplete2="matAutocomplete"
                (optionSelected)="selectedReviewerEvent2($event)"
              >
                <mat-option
                  *ngFor="let reviewer of searchedReviewer2"
                  [value]="reviewer.value"
                >
                  {{ reviewer.name }}
                </mat-option>
              </mat-autocomplete>
            </div>
            <div class="col-lg-2 mb-3">
              <label class="control-label fw">Review Status</label>
              <input
                type="text"
                placeholder="Pick one"
                aria-label="Number"
                name="reviewStatus"
                matInput
                [matAutocomplete]="autoRS"
                class="form-control form-control-sm border-bottom"
                [(ngModel)]="selfAssessmentNew.reviewStatus"
              />
              <mat-autocomplete autoActiveFirstOption #autoRS="matAutocomplete">
                <mat-option
                  *ngFor="let option of reviewStatus2"
                  [value]="option"
                >
                  {{ option }}
                </mat-option>
              </mat-autocomplete>
            </div>
          </div>

          <!-- <div class="row ml-2 mt-1">
            <div class="col-lg-12 mb-1">
              <div class="box-shadow p-2">
                <div class="header-text">
                  <span class="fa fa-chevron-down cursor-pointer" *ngIf="!isSA2Details6"
                    (click)="isSA2Details6 = true"></span>
                  <span class="fa fa-chevron-up cursor-pointer" *ngIf="isSA2Details6"
                    (click)="isSA2Details6 = false"></span>
                  <span class="control-label fw">
                    Review Details
                  </span>
                </div>
                <ckeditor id="reviewDetails" [editor]="Editor" *ngIf="isSA2Details6"
                  [(ngModel)]="selfAssessmentNew.reviewDetails"></ckeditor>
                  <app-ck-editor [(childVariable)]="selfAssessmentNew.reviewDetails" id="reviewDetails"
                  *ngIf="isSA2Details6"></app-ck-editor>
              </div>
            </div>
          </div> -->
        </div>
      </mat-expansion-panel>
    </mat-accordion>
    <mat-accordion id="ApprovalDetails">
      <mat-expansion-panel [expanded]="true" class="ia-expansion-panel pl-2">
        <mat-expansion-panel-header class="ia-mat-panel">
          <mat-panel-title>
            <span class="text-header inc-f"> Approval Details </span>
          </mat-panel-title>
        </mat-expansion-panel-header>
        <div>
          <div class="row ml-2 mt-1">
            <div class="col-lg-4 mb-3">
              <label class="control-label fw">Approval Team</label>
              <input
                type="text"
                placeholder="Pick one"
                aria-label="Number"
                name="approvalTeam"
                matInput
                [matAutocomplete]="autoAPT"
                class="form-control form-control-sm border-bottom"
                [(ngModel)]="selfAssessmentNew.approvalTeam"
              />
              <mat-autocomplete
                autoActiveFirstOption
                #autoAPT="matAutocomplete"
              >
                <mat-option
                  *ngFor="let option of approvalTeam2"
                  [value]="option"
                >
                  {{ option }}
                </mat-option>
              </mat-autocomplete>
            </div>
            <div class="col-lg-4 mb-3">
              <label class="control-label fw">Approver</label>
              <mat-chip-grid #approverList>
                <mat-chip-row
                  *ngFor="let approver of approverDD2"
                  [selectable]="selectable"
                  [removable]="removable"
                  (removed)="removeApprover2(approver)"
                >
                  {{ approver }}
                  <mat-icon matChipRemove *ngIf="removable">x</mat-icon>
                </mat-chip-row>
                <input
                  class="form-control form-control-sm h-33 mat-autodd-input border-bottom"
                  #approverInput2
                  [formControl]="searchApproverCntrl2"
                  [matAutocomplete]="approverAutocomplete2"
                  [matChipInputFor]="approverList"
                  [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                  [matChipInputAddOnBlur]="addOnBlur"
                  autocomplete="off"
                  (matChipInputTokenEnd)="addApprover2($event)"
                />
              </mat-chip-grid>
              <mat-autocomplete
                #approverAutocomplete2="matAutocomplete"
                (optionSelected)="selectedApproverEvent2($event)"
              >
                <mat-option
                  *ngFor="let approver of searchedApprover2"
                  [value]="approver.value"
                >
                  {{ approver.name }}
                </mat-option>
              </mat-autocomplete>
            </div>
            <div class="col-lg-4 mb-3">
              <label class="control-label fw">Approval Status</label>
              <!-- <input type="text" placeholder="Pick one" aria-label="Number" name="ApprovalStatus" matInput
                [matAutocomplete]="autoAS" class="form-control form-control-sm border-bottom"
                [(ngModel)]="selfAssessmentNew.approvalStatus" />
              <mat-autocomplete autoActiveFirstOption #autoAS="matAutocomplete">
                <mat-option *ngFor="let option of approvalStatus2" [value]="option">
                  {{option}}
                </mat-option>
              </mat-autocomplete> -->
              <input
                type="text"
                class="form-control form-control-sm"
                name="ApprovalStatus"
                [(ngModel)]="selfAssessmentNew.approvalStatus"
              />
            </div>
            <div class="col-lg-4 mb-3">
              <label class="control-label fw">Confirm Approval</label>
              <!-- <div class="d-flex gap-10 align-items-center flex-wrap mt-2">
                <span *ngFor="let approval of confirmApproval2">
                  <input type="checkbox" [(ngModel)]="approval.isConfirmed" (change)="toggleConfirmation(approval)" />
                  {{ approval.approverName }}
                </span>
              </div> -->
              <div
                class="d-flex gap-10 align-items-center flex-wrap"
                style="margin-top: 7px"
              >
                <span *ngFor="let approval of confirmApproval">
                  <input
                    type="checkbox"
                    [disabled]="approval.approverName != user.fullName"
                    [(ngModel)]="approval.isConfirmed"
                    (change)="toggleConfirmation(approval)"
                  />
                  {{ approval.approverName }}
                </span>
              </div>
            </div>
          </div>

          <!-- <div class="row ml-2 mt-1">
            <div class="col-lg-12 mb-1">
              <div class="box-shadow p-2">
                <div class="header-text">
                  <span class="fa fa-chevron-down cursor-pointer" *ngIf="!isSA2Details7"
                    (click)="isSA2Details7 = true"></span>
                  <span class="fa fa-chevron-up cursor-pointer" *ngIf="isSA2Details7"
                    (click)="isSA2Details7 = false"></span>
                  <span class="control-label fw">
                    Approval Comment
                  </span>
                </div>
                <ckeditor id="approvalComment" [editor]="Editor" *ngIf="isSA2Details7"
                  [(ngModel)]="selfAssessmentNew.approvalComment">
                </ckeditor>
                <app-ck-editor [(childVariable)]="selfAssessmentNew.approvalComment" id="approvalComment"
                *ngIf="isSA2Details7"></app-ck-editor>
              </div>
            </div>
          </div> -->
        </div>
      </mat-expansion-panel>
    </mat-accordion>
  </div>
</div>

<div *ngIf="templateNo == 3" class="row mt-1 mb-1 mx-1">
  <app-self-assessment-template3-overall-assessment
    [isBulkUpdate]="true"
    [selectedItems]="selectedItems"
  ></app-self-assessment-template3-overall-assessment>
</div>
